import { Ratings } from "../modules/ratings";

export const RatingsPage = () => {
  return <Ratings />;
};
